type MessageCommandGenerateDesigns = {
  type: "COMMAND:GENERATE_DESIGNS";
  source: "IHD";
};
type MessageEventGenerateDesigns = {
  type: "EVENT:GENERATE_DESIGNS";
  source: "IHD";
};
type MessageEventDesignEditCancel = {
  type: "DESIGN_EDIT_CANCEL";
  source: "IHD";
};
type MessageEventDesignEditComplete = {
  type: "DESIGN_EDIT_COMPLETE";
  payload?: {
    designId?: string;
  };
};
type MessageEventDesignEditBlocked = {
  type: "DESIGN_EDIT_BLOCKED";
  source: "IHD";
};
type MessageEventGoToDesign = {
  source: "Offer Experience";
  type: "IHD_HACK_GO_TO_DESIGN";
};
type MessageQueryAuthToken = {
  type: "QUERY:AUTH_TOKEN";
  source: "IHD";
  payload: {
    type: "IHD";
  };
};
type MessageEventAuthToken = {
  type: "EVENT:AUTH_TOKEN";
  source: "Offer Experience";
  payload: {
    token: string;
  };
};
type MessageEventUnrecoverableError = {
  type: "UNRECOVERABLE_ERROR";
  source: "IHD";
  payload: {
    error?: string;
  };
};
type MessageEventAppMounted = {
  type: "APP_MOUNTED";
  source: "IHD";
};
export type IhdMessage =
  | MessageCommandGenerateDesigns
  | MessageEventAppMounted
  | MessageEventAuthToken
  | MessageEventDesignEditCancel
  | MessageEventDesignEditBlocked
  | MessageEventDesignEditComplete
  | MessageEventGenerateDesigns
  | MessageEventGoToDesign
  | MessageQueryAuthToken
  | MessageEventUnrecoverableError;
export const logMessage = (message: IhdMessage) => {
  switch (message.type) {
    case "APP_MOUNTED":
    case "COMMAND:GENERATE_DESIGNS":
    case "IHD_HACK_GO_TO_DESIGN":
    case "DESIGN_EDIT_BLOCKED":
    case "DESIGN_EDIT_CANCEL":
    case "DESIGN_EDIT_COMPLETE":
    case "EVENT:AUTH_TOKEN":
    case "EVENT:GENERATE_DESIGNS":
    case "QUERY:AUTH_TOKEN":
    case "UNRECOVERABLE_ERROR":
      // eslint-disable-next-line no-console
      console.log(
        "📬",
        "source" in message ? message.source : "IHD",
        message.type,
        "payload" in message ? message.payload : undefined
      );
      break;
    default: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const never: never = message;
    }
  }
};
